<new-flowbanner [showPromo]="true"></new-flowbanner>
<div class="new-inmueble-top-wrapper">
  <app-newstepper *ngIf='!isLoading' [activeStep]="3"></app-newstepper>

  <div class="info-toast" *ngIf="infoToastVisible && !isLoading">
    <div class="info-toast-content">
      <div class="info-toast-bar"></div>
      <img src="./assets/img/svg/info.svg" alt="Información" class="info-toast-icon" />
      <div class="info-toast-text">
        <p class="info-toast-first-text">Las reclamaciones solo pueden ser presentadas por el propietario del inmueble o
          su apoderado.</p>
        <p class="info-toast-second-text">Si actúas como apoderado, te solicitaremos el poder notarial.</p>
      </div>
      <button type="button" class="info-toast-close" aria-label="Cerrar" (click)="closeInfoToast()">
        <img src="./assets/img/svg/Equis_linea.svg" alt="Cerrar" />
      </button>
    </div>
  </div>
</div>

<app-help-to-call></app-help-to-call>
<div class="container mt-3 mt-lg-5" *ngIf="!isLoading && loaded">
  <div class="row">
    <!-- Columna izquierda: mensaje e imagen -->
    <div class="col-12 col-md-6">
      <div class="text-center">
        <h1 class="h4">Completa los datos del inmueble a asegurar</h1>
        <!-- Imagen oculta en móviles -->
        <img src="./assets/img/Pago_aprobado_1080x1080.png" alt="Imagen" class="img-fluid d-none d-md-block" />
      </div>
    </div>

    <!-- Columna derecha: formulario -->
    <div class="col-12 col-md-6">
      <form [formGroup]="myForm" class="formulario">
        <!-- Campo Ciudad -->
        <!-- <div class="form-group">
          <label for="ciudad">*Ciudad</label>
          <select id="ciudad" name="ciudad" class="form-control" required>
            <option value="">Escribe y selecciona una ciudad</option>
          </select>
        </div> -->


        <auto-complete-input [form]="myForm" controlName="ubicacion" label="*Ciudad" [options]="ciudadesDepartamento"
          [data]="locations" (optionSelected)="onOptionSelected($event)">
        </auto-complete-input>

        <!-- Dirección del inmueble -->
        <h5>Dirección del inmueble</h5>
        <div class="address-info-msg">
          <p>La dirección debe
            <span class="text-highlight">coincidir</span>
            con el certificado de tradición y libertad que a su vez será necesario en caso de presentar una reclamación.
          </p>
        </div>

        <!-- Tipo y número de vía -->
        <div class="form-group" id="address-group">
          <label for="tipoVia"
            [class.text-danger]="myForm.get('tipoVia')?.invalid && myForm.get('tipoVia')?.touched">*Tipo y número de
            vía</label>
          <div class="input-group">
            <select id="tipoVia" class="form-control" formControlName="tipoVia" required (change)="selectedType()"
              (blur)="validateAddressFields()">
              <option value="" selected>
                Selecciona el tipo de vía
              </option>
              @for (option of validityOptions; track option) {
              <option [value]="option.value">{{ option.label }}</option>
              }
            </select>

            <!-- <general-select [form]="myForm" controlName="tipoVia" label="Tipo y número de vía"
              [options]="validityOptions" [showPlaceholder]="true"></general-select>
             -->
            <input formControlName="numVia" type="text" id="numVia" name="numVia" class="form-control"
              placeholder="Ej: 32C" required (blur)="validateAddressFields()" />

            <!-- <generalinput [form]="myForm" controlName="numVia" label="" placeholder="Ej: 32C" [isAlphaOnly]="true">
            </generalinput> -->
          </div>


          <label for="nomenclatura" class="mt-3" [class.text-danger]="myForm.get('currVia')?.invalid && myForm.get('currVia')?.touched || 
          myForm.get('compVia')?.invalid && myForm.get('compVia')?.touched">*Nomenclatura</label>
          <div class="input-group ">

            <p class="form-control-plaintext">#</p>

            <input formControlName="currVia" type="text" id="numero" name="numero" class="form-control" placeholder="45"
              required (blur)="validateAddressFields()" />

            <p class="form-control-plaintext">-</p>

            <input formControlName="compVia" type="text" id="numero2" name="numero2" class="form-control"
              placeholder="116" required (blur)="validateAddressFields()" />

            <input [ngClass]="{'input-empty': !myForm.get('apto')?.value}" formControlName="apto" type="text"
              id="apartamento" name="apartamento" class="form-control" placeholder="Apto 257"
              (blur)="validateAddressFields()" />

          </div>

          @if(!isValidAdress()){
          <div class="text-danger danger-text">
            <small class="maxwithalert" style="font-size: 14px;  ">Asegúrate de ingresar una dirección válida</small>
          </div>
          }

        </div>

        <!-- Nomenclatura -->
        <!-- <div class="form-group">

        </div> -->




        <!-- Urbanización o Barrio -->
        <div class="form-group">
          <label for="documento">Urbanización o Barrio (opcional)</label>
          <input [ngClass]="{'input-empty': !myForm.get('barrio')?.value}" formControlName="barrio" type="text"
            id="documento" name="barrio" class="form-control" placeholder="Ej: Urbanización Rosal"
            (blur)="validateAddressFields()" />

          <!-- <generalinput [form]="myForm" controlName="barrio" label="Urbanización o Barrio (opcional)" placeholder="Ej: Urbanización Rosal" [isAlphaOnly]="true"></generalinput> -->
        </div>

        <!-- Resumen de la dirección -->
        <div class="form-group">
          <label for="fechaExpedicion">Resumen de la dirección</label>
          <input formControlName="resumenDireccion" type="text" id="fechaExpedicion" name="fechaExpedicion"
            class="form-control" required />

          <!-- <generalinput [form]="myForm" controlName="resumenDireccion" label="Resumen de la dirección" placeholder=""
            [isAlphaOnly]="true" [value]="directionSummary()" [isReadOnly]="true"></generalinput> -->
        </div>

        <!-- Fecha de inicio del contrato -->
        <div class="form-group">
          <!-- <label for="fechaContrato">*Fecha de inicio del contrato</label>
          <input type="text" id="fechaContrato" name="fechaContrato" class="form-control" placeholder="DD/MM/AA"
            required />
          <span class="input-group-addon">
            <i class="fas fa-calendar-alt"></i>
          </span> -->

          <generaldate [form]="myForm" controlName="fechaInicialContrato" label="*Fecha inicio del contrato"
            alertMessage="Asegúrate de llenar este campo" [minDate]="today" [maxDate]="maxDate" placeholder="DD/MM/AA"
            [isReadOnly]="false" [allowFutureDates]="true">
          </generaldate>
        </div>

        <!-- Campos obligatorios -->
        <div class="form-group">
          <small class="message">*Los campos son obligatorios</small>
        </div>

        <!-- Checkbox -->
        <div [formGroup]="myForm" class="checkbox-container form-check d-flex align-items-center">
          <!-- <general-chebox [form]="myForm" controlName="flexCheckAutoriza" label="*Tipo de identificación" ></general-chebox> -->
          <input type="checkbox" formControlName="flexCheckAutoriza" id="checkbox" name="checkbox"
            class="form-check-input" />
          <label for="checkbox" class="form-check-label ml-2">
            Declaro que soy propietario o apoderado del inmueble a arrendar lo
            cual consta en
            <span class="highlight">Certificado de Tradición</span> y Libertad o
            en un documento certificado y autenticado que me autoriza a arrendar
            el inmueble y que certifica que este se destinará para uso
            residencial.
          </label>
        </div>

        <!-- Botón de Continuar -->
        <button class="btn btn-primary mt-3" [disabled]="myForm.invalid" (click)="openModal()">
          Continuar
        </button>
      </form>
    </div>
  </div>

  <!-- Modal -->
  <!-- Modal -->
  <div class="modal-container" *ngIf="isModalOpen">
    <div class="modal">
      <span class="close-btn" (click)="closeModalButton()">
        <img class="cerrar-blanco" src="./assets/img/close-white.png" alt="Cerrar" />
      </span>

      <div class="modal-content" [formGroup]="myForm">
        <h2 class="modal-title">
          ¿Confirmas que esta es la <br> dirección del inmueble?
        </h2>

        <!-- Campo de entrada con el valor de la cédula -->
        <div class="input-container">
          <!-- <input id="direccion" class="form-label-input" formControlName="resumenDireccionFinal" /> -->
          <generalinput [form]="myForm" controlName="resumenDireccionFinal" [isAlphaOnly]="false" label=""
            alertMessage="Asegúrate de llenar este campo" placeholder="" class="direction-summary-modal">
          </generalinput>
          <img src="./assets/img/Lapiz.png" alt="Editar" class="input-icon align-items-left" />
        </div>
        <button class="btn btn-cerrar" type="submit" (click)="onSubmit()" [disabled]="myForm.invalid || isClicked">
          Continuar
        </button>
      </div>
    </div>
  </div>

</div>
<app-footer-app></app-footer-app>